export const PAGE = {
  CARD_LIST: "/",
  ADD_CARD: "/add-card",
  NAME_CARD: "/name-card",
};
